var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui selection dropdown', { multiple: _vm.multiple }]},[_c('input',{attrs:{"type":"hidden"},on:{"change":_vm.onInputChanged}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }